/**
 * Wspólne klasy pól formularzy w rendererach kartotek (`*CoreRenderers.tsx`).
 *
 * Ten sam string klas był skopiowany w 9 plikach core-rendererów. Wyniesiony tu,
 * żeby styl pola żył w jednym miejscu. Dwa warianty różnią się WYŁĄCZNIE kolorem
 * tekstu pola wyłączonego (`disabled:text-text-tertiary`) — zachowane osobno 1:1,
 * żeby nie zmienić wyglądu żadnego istniejącego ekranu.
 *
 * Rozmiar Md (40px) + focus/read-only/error/success — wg macierzy inputów z systemu
 * Workflow 3.0 (Figma „08.2 · Inputs & forms"), ten sam wzorzec co w `Input.tsx`.
 */

/** Wariant bazowy — kontrahenci, pracownicy, użytkownicy, kontakty. */
export const CORE_INPUT_CLASS =
  'w-full h-10 rounded-lg border border-border-secondary bg-bg-primary px-3 text-sm ' +
  'transition-colors hover:border-border-primary ' +
  'focus:outline-none focus:border-accent-600 focus:ring-[3px] focus:ring-accent-600 ' +
  'read-only:cursor-default read-only:border-transparent read-only:bg-bg-tertiary ' +
  'disabled:cursor-not-allowed disabled:border-transparent disabled:bg-bg-secondary';

/** Jak wyżej + wyszarzony tekst pola wyłączonego — dokumenty, umowy, faktury. */
export const CORE_INPUT_CLASS_MUTED_DISABLED = `${CORE_INPUT_CLASS} disabled:text-text-tertiary`;

/** Ramka błędu — kolor `color/error/base` z Figmy (#da2134), nie surowy Tailwind red. */
export const CORE_INPUT_INVALID_CLASS =
  'border-[rgb(var(--color-error))] focus:border-[rgb(var(--color-error))] focus:ring-[rgb(var(--color-error))]';

/** Ramka sukcesu — kolor `color/success/base` z Figmy (#22b573). */
export const CORE_INPUT_SUCCESS_CLASS =
  'border-[rgb(var(--color-success))] focus:border-[rgb(var(--color-success))] focus:ring-[rgb(var(--color-success))]';
